import axiosClient from '~/apis/axiosClient';
import { urlApiReport } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';
import { IFormatDataReportRes, IJobDistributionItemRes, IQueryParamReport } from '~/utils/interface/report';

const reportApi = {
  getServiceVolume: (payload: IQueryParamReport) => {
    const url = urlApiReport.getServiceVolume;
    return axiosClient.get<IBaseResponse<IFormatDataReportRes>>(url, { params: payload });
  },

  getAverageJob: (payload: IQueryParamReport) => {
    const url = urlApiReport.getAverageJob;
    return axiosClient.get<IBaseResponse<IFormatDataReportRes>>(url, { params: payload });
  },

  getPurchaseOderTotal: (payload: IQueryParamReport) => {
    const url = urlApiReport.getPurchaseOderTotal;
    return axiosClient.get<IBaseResponse<IFormatDataReportRes>>(url, { params: payload });
  },

  getSaleByCity: (payload: IQueryParamReport) => {
    const url = urlApiReport.getSaleByCity;
    return axiosClient.get<IBaseResponse<IFormatDataReportRes>>(url, { params: payload });
  },

  getJobDistribution: (payload: IQueryParamReport) => {
    const url = urlApiReport.getJobDistribution;
    return axiosClient.get<IBaseResponse<IJobDistributionItemRes[]>>(url, { params: payload });
  },
};

export default reportApi;
